const TOKEN_KEY = "salesapp-token"
const ROLE_KEY  = "salesapp-role"

export function save_token(token: string): void {
  try { localStorage.setItem(TOKEN_KEY, token) } catch { /* ignore */ }
}

export function load_token(): string {
  try { return localStorage.getItem(TOKEN_KEY) ?? "" } catch { return "" }
}

export function clear_token(): void {
  try { localStorage.removeItem(TOKEN_KEY) } catch { /* ignore */ }
}

export function save_role(role: string): void {
  try { localStorage.setItem(ROLE_KEY, role) } catch { /* ignore */ }
}

export function load_role(): string {
  try { return localStorage.getItem(ROLE_KEY) ?? "" } catch { return "" }
}

export function clear_role(): void {
  try { localStorage.removeItem(ROLE_KEY) } catch { /* ignore */ }
}

// Decode JWT payload to extract role — works offline without re-login.
// Falls back to empty string if token missing or malformed.
export function decode_role_from_token(): string {
  try {
    const token = load_token()
    if (!token) return ""
    const payload = JSON.parse(atob(token.split(".")[1]))
    // Try common field names used in FastAPI JWT backends
    return payload.role ?? payload.user_role ?? payload.sub_role ?? ""
  } catch { return "" }
}
